const isUserOnIE = (): boolean => {
  // Checks if the current browser is IE
  const userAgent = typeof window === 'object' && window.navigator.userAgent;
  const isIE = /MSIE|Trident/.test(userAgent);

  return isIE;
};

export default isUserOnIE;
